/* Copyright (c) 2019 - 2021. Verimatrix. All Rights Reserved.
   All information in this file is Verimatrix Confidential and Proprietary. */

import React, { useState } from "react";
import { Table, Icon, Grid } from "semantic-ui-react";
import styles from "../MyAccount.module.css";

interface FreeTrialsProps {
  data: any;
}

const FreeTrials: React.FC<FreeTrialsProps> = ({ data }) => {
  const [sorting, setSorting] = useState<any>({
    sortBy: "org",
    reverse: false,
  });

  const sortTrials = (valueA: any, valueB: any) => {
    let sortValueA, sortValueB;

    switch (sorting.sortBy) {
      case "expiry":
        sortValueA = valueA.trialExpires;
        sortValueB = valueB.trialExpires;
        break;

      case "hasSignedIn":
        sortValueA = valueA.hasSignedIn;
        sortValueB = valueB.hasSignedIn;
        break;

      case "appsProtected":
        sortValueA = valueA.apsNumProtections;
        sortValueB = valueB.apsNumProtections;
        break;

      case "appInstances":
        sortValueA = valueA.appInstances;
        sortValueB = valueB.appInstances;
        break;

      default:
        sortValueA = valueA.orgName;
        sortValueB = valueB.orgName;
    }

    if (!sortValueA) {
      sortValueA = "";
    }
    if (!sortValueB) {
      sortValueB = "";
    }

    if (sortValueA < sortValueB) {
      return sorting.reverse ? 1 : -1;
    } else if (sortValueA > sortValueB) {
      return sorting.reverse ? -1 : 1;
    }
    return 0;
  };

  const setOrgSorting = (sortBy: string) => {
    setSorting({
      sortBy: sortBy,
      reverse: sortBy === sorting.sortBy ? !sorting.reverse : false,
    });
  };

  const getSortIndicator = (columnName: string) => {
    if (sorting.sortBy === columnName) {
      return (
        <Icon
          name={sorting.reverse ? "triangle down" : "triangle up"}
          style={{ marginLeft: "3px" }}
        />
      );
    }
    return null;
  };

  const trialsRow = (trial: any, idx: number) => {
    return (
      <Table.Row key={idx}>
        <Table.Cell>{trial.orgName}</Table.Cell>
        <Table.Cell>
          {new Date(trial.trialExpires).toLocaleDateString(navigator.language)}
        </Table.Cell>
        <Table.Cell>{trial.hasSignedIn ? "Yes" : "No"} </Table.Cell>
        <Table.Cell>{trial.apsNumProtections}</Table.Cell>
        <Table.Cell>{trial.appInstances}</Table.Cell>
      </Table.Row>
    );
  };

  if (data && data.length > 0) {
    const sortedOrgs = data.sort((orgA: any, orgB: any) =>
      sortTrials(orgA, orgB)
    );

    return (
      <Table sortable celled compact="very" className={styles.usersTable}>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell
              onClick={() => {
                setOrgSorting("org");
              }}
            >
              Organization
              {getSortIndicator("org")}
            </Table.HeaderCell>

            <Table.HeaderCell
              onClick={() => {
                setOrgSorting("expiry");
              }}
            >
              Expiry
              {getSortIndicator("expiry")}
            </Table.HeaderCell>

            <Table.HeaderCell
              onClick={() => {
                setOrgSorting("hasSignedIn");
              }}
            >
              Logged In
              {getSortIndicator("hasSignedIn")}
            </Table.HeaderCell>

            <Table.HeaderCell
              onClick={() => {
                setOrgSorting("appsProtected");
              }}
            >
              Apps Protected
              {getSortIndicator("appsProtected")}
            </Table.HeaderCell>

            <Table.HeaderCell
              onClick={() => {
                setOrgSorting("appInstances");
              }}
            >
              App Instances
              {getSortIndicator("appInstances")}
            </Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {sortedOrgs.map((org: any, idx: number) => trialsRow(org, idx))}
        </Table.Body>
      </Table>
    );
  }

  return (
    <Grid>
      <Grid.Column textAlign="center">
        <div className={styles.myAccountNoUsersLabel}>
          {(data && "No data.") || ""}
        </div>
      </Grid.Column>
    </Grid>
  );
};

export default FreeTrials;
